import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, AppDispatch } from '../../app/store'
import { MapPin, ChevronLeft, ChevronRight, X } from 'lucide-react'
import { clearDeliveryAddressLocally } from '../../features/cart/cartSlice'

interface AddressSelectorProps {
  onAddressSelect?: () => void
}

const AddressSelector: React.FC<AddressSelectorProps> = ({
  onAddressSelect
}) => {
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const { settings } = useSelector((state: RootState) => state.settings)
  const deliveryAddress = useSelector((state: RootState) => state.cart.delivery_address)
  const addressId = useSelector((state: RootState) => state.cart.address_id)

  const hasAddress = Boolean(addressId) || Boolean(deliveryAddress?.id)

  const displayText = deliveryAddress?.name
    || deliveryAddress?.address
    || (hasAddress
      ? (t('cs.selected_address') || 'تم اختيار العنوان')
      : (t('cs.delivery_address_placeholder') || 'اختر عنوان التوصيل'))

  const handleClearAddress = (e: React.MouseEvent) => {
    e.stopPropagation()
    dispatch(clearDeliveryAddressLocally())
  }

  return (
    <div
      onClick={onAddressSelect}
      className="self-stretch h-14 pl-3 pr-4 bg-white rounded-xl inline-flex justify-between items-center gap-2 overflow-hidden cursor-pointer"
    >
      <div className="flex flex-row gap-3 items-center justify-start flex-1 min-w-0">
        <MapPin className="w-5 h-5 text-[#525866] flex-shrink-0" />
        <div className="text-text-primary text-sm font-medium font-['IBM_Plex_Sans_Arabic'] truncate">
          {displayText}
        </div>
      </div>

      <div className="flex items-center gap-2 flex-shrink-0">
        {hasAddress ? (
          <button
            onClick={handleClearAddress}
            className="h-8 w-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors"
            aria-label={t('common.remove') || 'Remove address'}
          >
            <X className="w-4 h-4 text-gray-600" />
          </button>
        ) : (
          settings.language === 'ar' ? (
            <ChevronLeft className="w-5 h-5 text-[#525866]" />
          ) : (
            <ChevronRight className="w-5 h-5 text-[#525866]" />
          )
        )}
      </div>
    </div>
  )
}

export default AddressSelector
